import FinanceApp from "./FinanceApp";

export default FinanceApp;
